// Mock data para el portafolio

export const aboutData = {
  name: "Orellana",
  title: "Licenciado en Informática",
  location: "Palpalá, Jujuy",
  bio: `Nacido en la ciudad de Palpalá, provincia de Jujuy.
Perteneciente a la Generación X, hijo de Don "Pichi" y la "Horte".

`,
  image: "/img/YO.jpg",
};

export const servicesData = {
  title: "Servicios que ofrezco",
  description: "Desarrollo de software a medida que impulse tu negocio, con soluciones innovadoras centradas en el usuario y adaptada a su necesidad.",
  services: [
    {
      id: 1,
      title: "Desarrollo Web",
      description: "Aplicaciones web modernas y escalables con las últimas tecnologías",
      icon: "Globe"
    },
    {
      id: 2,
      title: "Aplicaciones Móviles",
      description: "Apps nativas y multiplataforma para iOS y Android",
      icon: "Smartphone"
    },
    {
      id: 3,
      title: "Consultoría IT",
      description: "Asesoramiento técnico para optimizar tus procesos digitales",
      icon: "Lightbulb"
    },
    {
      id: 4,
      title: "Arquitectura de Software",
      description: "Diseño de sistemas robustos y mantenibles",
      icon: "Layers"
    }
  ]
};

export const blogData = [
  {
    id: 1,
    title: "Lenovo se ha inventado un portátil transformer y modular",
    excerpt: "Explorando las tendencias que están transformando la industria del software",
    date: "2026-01-15",
    category: "Tecnología",
    image: "https://i.blogs.es/3107b1/lenovo-thinkbook-transformer-3/840_560.jpeg",
    readTime: "5 min",
    url: "https://www.xataka.com/analisis/lenovo-se-ha-inventado-portatil-transformer-modular-se-desmontan-puertos-hemos-probado"
  },
  {
    id: 2,
    title: "El Honor Robot Phone lo mismo baila tu música que te hace fotos",
    excerpt: "Principios y patrones para construir software sostenible",
    date: "2026-01-10",
    category: "Desarrollo",
    image: "https://i.blogs.es/725721/robot-phone-5/840_560.jpeg",
    readTime: "8 min",
    url: "https://www.xataka.com/moviles/he-visto-resultado-noche-loca-movil-robot-honor-robot-phone-baila-tu-musica-que-te-hace-fotos"
  },
  {
    id: 3,
    title: "El apocalipsis de la IA está cerca. Buena suerte, diviértete, no mueras",
    excerpt: "Cómo el diseño centrado en el usuario mejora los resultados",
    date: "2026-01-05",
    category: "UX/UI",
    image: "https://cdn.arstechnica.net/wp-content/uploads/2026/02/GLHFDD-TOP-1152x617.jpg",
    readTime: "6 min",
    url: "https://arstechnica.com/culture/2026/02/the-ai-apocalypse-is-nigh-in-good-luck-have-fun-dont-die/"
  }
];
export const tesoroData = {
  title: "Proyectos",
  subtitle: "Los 4 grandes proyectos, implementados y en desarrollo, concebidos bajo Arquitectura Orellana.Cuatro sistemas con identidad propia, diseñados para responder a distintas dinámicas, pero unidos por una misma lógica estructural: precisión, movimiento, creatividad y expansión. Cada uno representa una dimensión estratégica distinta, y juntos conforman un ecosistema integral.",
  items: [
    {
      id: 1,
      title: "Sistema EJE",
      description: "Solución orientada a la precisión y el análisis estructural, diseñada para entornos donde cada decisión requiere coherencia y exactitud matemática. Especializado en el procesamiento de datos, cálculos complejos y optimización numérica, combina lógica avanzada con estabilidad operativa. Su funcionamiento es metódico, inteligente y confiable, aportando equilibrio y armonía a cada proceso que gestiona.",
      tech: ["React", "Python", "PostgreSQL"],
      image: "/img/1.jpg",
      year: "Bebote"
    },
    {
      id: 2,
      title: "Sistema PULSO",
      description: "Diseñado con una interfaz moderna y elegante, destaca por su capacidad de interacción y adaptabilidad en entornos dinámicos. Optimizado para la gestión de eventos, comunidades y actividades colaborativas, combina carisma funcional con rendimiento sólido. Flexible en su ejecución, pero preciso cuando el contexto exige desempeño competitivo, con IA incorporada para potenciar cada decisión",
      tech: ["React Native", "Node.js", "MongoDB"],
      //image: "https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?w=800&h=600&fit=crop",
      image: "/img/2.jpg",
      year: "Bebito"
    },
    {
      id: 3,
      title: "Sistema LUZ",
      description: "Solución orientada al diseño y la experiencia del usuario, con una arquitectura delicada pero cuidadosamente construida. Prioriza la armonía visual, la creatividad en los procesos y la generación de entornos amables e intuitivos. Funciona a su propio ritmo, optimizando recursos con calma estratégica y ofreciendo resultados estéticamente impecables.",
      tech: ["Vue.js", "FastAPI", "MySQL"],
      //image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&h=600&fit=crop",
      image: "/img/3.jpg",
      year: "Bebota"
    },
    {
      id: 4,
      title: "Sistema ÍMPETU",
      description: "Motor dinámico de alta energía, diseñado para entornos cambiantes y escenarios de rápida adaptación. Su arquitectura flexible le permite transformar conflictos en soluciones ágiles, priorizando la experiencia del usuario con una interacción cercana y empática. Creativo por naturaleza, incorpora imaginación estratégica en cada proceso, convirtiendo desafíos en oportunidades evolutivas.",
      tech: ["Python", "Django", "PostgreSQL"],
      //image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop",
      image: "/img/4.jpg",
      year: "Bebé"
    }
  ]
};

export const contactData = {
  email: "contacto@orellana.com.ar",
  phone: "+54 9 388 123-4567",
  location: "Palpalá, Jujuy, Argentina",
  social: [
    { name: "GitHub", url: "#", icon: "Github" },
    { name: "LinkedIn", url: "#", icon: "Linkedin" },
    { name: "Twitter", url: "#", icon: "Twitter" }
  ]
};

export const formacionData = {
  title: "Formación",
  subtitle: "Títulos y certificaciones académicas",
  degrees: [
    {
      id: 1,
      title: "Analista Programador",

      institution: "Formación técnica orientada al desarrollo de software, algoritmos y estructuras de datos. Enfoque en programación orientada a objetos, bases de datos y desarrollo de aplicaciones.",

      year: "Completado",
      icon: "Code"
    },
    {
      id: 2,
      title: "Analista de Sistemas de Computación",
      institution: "Carrera centrada en el análisis, diseño y modelado de sistemas informáticos. Formación en bases de datos, redes, arquitectura de computadoras y gestión de proyectos tecnológicos.",

      year: "Completado",
      icon: "Database"
    },
    {
      id: 3,
      title: "Licenciado en Informática",
      institution: "Formación universitaria integral con enfoque en investigación, ingeniería de software y arquitectura de sistemas. Desarrollo de soluciones tecnológicas complejas y liderazgo de equipos.",

      year: "Completado",
      icon: "GraduationCap"
    },
    {
      id: 4,
      title: "Profesor de Grado Universitario en Informática",
      institution: "Formación pedagógica y disciplinar orientada a la enseñanza de la informática en nivel medio y superior. Diseño de propuestas didácticas, planificación curricular e integración de tecnologías educativas.",

      year: "Completado",
      icon: "BookOpen"
    }
  ]
};